import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { TextboxComponent } from "../../../design-system/textbox/textbox.component";
import { TextboxConfig } from "../../../design-system/textbox/textbox.modal";

@Component({
    selector: 'textbox-renderer',
    templateUrl: './textbox-renderer.component.html',
    standalone: true,
    imports: [TextboxComponent]
})

export class TextboxRendererComponent implements ICellRendererAngularComp {
    placeHolder = "";
    maxLength: number;
    value: any;
    params: any;
    isRequired: boolean = false;
    showValidator: boolean = false;
    isShowText: boolean = false;
    disabled: boolean = false;
    isShowValidationOnInit: boolean = false;
    textboxConfig: TextboxConfig = {
        id: '',
        placeholder: '',
        required: false,
        disabled: false,
        size: 'sm',
    };

    initilize(params: ICellRendererParams) {
        if (params && params.data) {
            this.isShowText = params.data?.isShowText;
            this.disabled = params.data?.disabled;
            this.isRequired = params.data?.isRequired;
        }

        if (params.colDef.headerComponentParams) {
            this.isShowText = false;
            this.disabled = false;
            this.isRequired = true;
            this.isRequired = params.colDef.headerComponentParams?.isRequired;
            this.placeHolder = params.colDef.headerComponentParams?.placeHolder;
            this.isShowValidationOnInit = params.colDef.headerComponentParams?.isShowValidationOnInit;
        }

        this.value = params.getValue();

        if (this.isShowValidationOnInit && !this.value) {
            this.showValidator = true;
        }
        this.textboxConfig = {
            ...this.textboxConfig,// value: this.value,
            placeholder: this.placeHolder, maxLength: this.maxLength, required: this.isRequired, disabled: this.disabled
        };
    }

    agInit(params: any): void {
        this.params = params;
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    onInput($event) {
        if (this.params.onInput instanceof Function) {
            this.showValidator = false;
            this.params.setValue($event.target.value);
            let params = { event: $event, rowData: this.params.node.data }
            this.params.onInput(params);
            if (params.rowData.isRequired) {
                this.isRequired = params.rowData.isRequired;
                this.textboxConfig = { ...this.textboxConfig, required: this.isRequired };
            }
            if (!this.NoWhitespaceValidator($event.target.value) && this.isRequired) {
                this.showValidator = true;
                return;
            }
        }
    }


    NoWhitespaceValidator(value: string): boolean {
        if (value == null) {
            value = "";
        }
        const isWhitespace = (value || "").trim().length === 0;
        return !isWhitespace;
    }

    onKeypress(event) {
        if (this.params.colDef.headerComponentParams?.type === 'twoDecimalNumber') {
            const regex = /^\d*\.?\d{0,2}$/;
            let str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (regex.test(str))
                return true;
            else return false;
        }
    }

}
